import { useEffect } from 'react';

const lAST_SEEN_POST_ID = 'last_post_id';
const COMMUNITY_VISITED = 'visited_community';

export const useCommunityIndicator = (isCommunityPage?: boolean) => {
  useEffect(() => {
    if (isCommunityPage) {
      const visitedCommunity = localStorage.getItem(`${COMMUNITY_VISITED}`);
      if (!visitedCommunity) {
        localStorage.setItem(COMMUNITY_VISITED, JSON.stringify(true));
      }
    }
  }, []);

  const isCommunityVisited = () => {
    const visitedCommunity = localStorage.getItem(COMMUNITY_VISITED);
    return !!visitedCommunity;
  };

  const getLastSeenPostId = () => {
    const savedLastSeenPostId = localStorage.getItem(lAST_SEEN_POST_ID);
    return JSON.parse(savedLastSeenPostId ?? 'null');
  };

  const setLastSeenPostId = (id: string) => {
    localStorage.setItem(lAST_SEEN_POST_ID, JSON.stringify(id));
  };

  return {
    getLastSeenPostId,
    setLastSeenPostId,
    isCommunityVisited,
  };
};
